import { useEffect, useReducer, Reducer } from "react";
import axios from "axios";

interface StateType<T> {
    data: T | null,
    isLoading: boolean,
    errorMessage: null| string
}

const initialState: StateType<any> = {
    data: null,
    isLoading: true,
    errorMessage: null
}

const reducer: Reducer<StateType<any>, any> = (state: StateType<any>, action: any) => {
    switch (action.type) {
        case  "FETCH_DATA_SUCCESS": {
            return {
                data: action.data,
                isLoading: false,
                errorMessage: null
            };
        }
        case "FETCH_DATA_FAIL": {
            return {
                data: null,
                isLoading: false,
                errorMessage: action.errorMessage
            };
        }
        default: {
            return state;
        }
    }
}

function useFetch<T>(endpoint: string){


    const [state, dispatch] = useReducer<Reducer<StateType<T>, any>>(reducer, initialState);

    useEffect(() => {
        const controller = new AbortController()
        const { signal } = controller

        const fetchData = () => {
            axios
                .get(process.env.PUBLIC_URL + "/data/" + endpoint, {
                    signal
                })
                .then(response => {
                    dispatch({ type: "FETCH_DATA_SUCCESS", data: response.data});
                })
                .catch(error => {
                    dispatch({ type: "FETCH_DATA_FAIL", errorMessage: error.message});
                });
        }

        fetchData();
    
        return () => {
            controller.abort()
        }
    }, [endpoint]);

    return state;
}

export default useFetch;